import styled from 'styled-components';

export const EmailLink = styled.a`
  color: ${p => p.theme.primaryColor};
  text-decoration: underline;
`;
